import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  wrapper: function wrapper() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      overflow: hidden;\n      position: absolute;\n      pointer-events: none;\n    "])));
  }
});